module.exports = __webpack_public_path__ + "static/media/wesko-eLock_logo.d9f82ed8.jpeg";